registerComponent("product-blocks/product-documents", function (component) {

});
